<template>

  <v-autocomplete v-model="teamID"
                  :label="label || 'Team'"
                  :placeholder="placeholder"
                  :items="teams"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :no-filter="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"
                  :search-input.sync="textInput">
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <p>{{ item.name }}</p>
        <!-- <div class="club-container">
          <div class="club-logo-container">
            <img class="club-logo-img" v-if="!item.logoURL" src="../../../static/icons/club-icon-256x256-darkblue.png"/>
            <img class="club-logo-img" v-if="item.logoURL" :src="item.logoURL"/>
          </div>
          <p class="club-name">{{ item.alias }} - <b class="item-text-small">{{ getSportName(item.sportID) }}</b></p>
        </div> -->
      </v-list-tile-content>
    </template>
  </v-autocomplete>

</template>

<script>

export default {
  name: 'TeamSelector',
  props: [
    'currentTeamID',
    'clubID',
    'label',
    'disabled',
    'disabledText'
  ],
  data () {
    return {
      loading: false,
      teams: [],
      teamID: '',

      textInput: '',

      preventNextSearch: false
    }
  },
  mounted () {
    if (this.currentTeamID) {
      this.setCurrentTeam()
    }
  },
  methods: {
    handleInput (input) {
      this.loading = false
      this.textInput = input
      setTimeout(() => {
        if (input && (this.textInput === input)) {
          this.loading = true
          this.loadTeams()
        }
      }, 400)
    },
    setCurrentTeam () {
      this.loading = true
      this.$store.dispatch('getTeam', this.currentTeamID)
        .then(resp => {
          this.preventNextSearch = true
          this.teams = [resp]
          this.teamID = this.currentTeamID
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading team')
          this.loading = false
        })
    },
    loadTeams () {
      if (this.preventNextSearch) {
        this.loading = false
        this.preventNextSearch = false
        return
      }

      let searchparams = {
        name: this.textInput
      }
      if (this.clubID) {
        searchparams.clubID = this.clubID
      }

      this.$store.dispatch('fetchTeams', searchparams)
        .then(resp => {
          this.teams = resp.items
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading teams')
          this.loading = false
        })
    },
    clear () {
      this.teamID = ''
      this.teams = []
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || false
    },
    placeholder () {
      return this.isDisabled ? (this.disabledText || '') : (this.label || 'Team')
    }
  },
  watch: {
    'textInput' () {
      if (this.textInput) {
        this.handleInput(this.textInput)
      } else {
        this.teams = []
      }
    },
    'clubID' () {
      this.clear()
    },
    'teamID' () {
      this.$emit('teamSelected', this.teamID || '')
    },
    'currentTeamID' () {
      if (this.currentTeamID) {
        this.setCurrentTeam()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.item-text-small {
  font-size: 11px;
}

.club-container {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 12px;
}

.club-logo-container {
  align-self: center;
  width: 30px;
  height: 30px;
  border: 1px solid #cccccc;
  border-radius: 50%;
  display: grid;
}

.club-logo-img {
  max-width: 18px;
  max-height: 18px;
  justify-self: center;
  align-self: center;
}

.club-name {
  align-self: center;
  font-size: 13px;
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/TeamSelector.vue